import { Box, IconButton, Drawer, useMediaQuery, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MapView from '../../../components/MapComponent/MapView';
import ListIcon from '@mui/icons-material/List';
import CloseIcon from '@mui/icons-material/Close';
import LocationList from './LocationList';
import { LocationProvider } from './LocationContext';

const LocationIndex = () => {
    const { t } = useTranslation();
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [selectedIds, setSelectedIds] = useState<string[]>([]); 
    const isMobile = useMediaQuery('(max-width:900px)');
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <LocationProvider>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    height: '100vh',
                    gap: { xs: 1, md: 2 },
                    p: { xs: 1, md: 2 }
                }}
            >

                {!isMobile && sidebarOpen && (
                    <Box
                        sx={{
                            width: { md: 400, lg: 450 },
                            overflowY: 'auto',
                            position: 'relative',
                        }}
                    >
                        {/*<IconButton*/}
                        {/*    onClick={() => setSidebarOpen(false)}*/}
                        {/*    sx={{ position: 'absolute', top: 10, right: 8 }}*/}
                        {/*>*/}
                        {/*    <CloseIcon />*/}
                        {/*</IconButton>*/}

                        <LocationList
                            onSelect={(id) => setSelectedId(id)}
                            selectedIds={selectedIds}
                            setSelectedIds={setSelectedIds}
                            onClose={() => setSidebarOpen(false)}
                        />
                    </Box>
                )}

                {isMobile && (
                    <Drawer
                        anchor="left"
                        open={sidebarOpen}
                        onClose={() => setSidebarOpen(false)}
                        PaperProps={{
                            sx: { width: '100vw', maxWidth: 420 }
                        }}
                    >
                        <Box sx={{ width: '100%', p: 2 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mb: 2
                                }}
                            >
                                <IconButton onClick={() => setSidebarOpen(false)}>
                                    <CloseIcon fontSize="medium" />
                                </IconButton>
                            </Box>

                            <LocationList
                                onSelect={(id) => {
                                    setSelectedId(id);
                                    setSidebarOpen(false);
                                }}
                                selectedIds={selectedIds}
                                setSelectedIds={setSelectedIds}
                                onClose={() => setSidebarOpen(false)}
                            />
                        </Box>
                    </Drawer>
                )}

                <Box
                    sx={{
                        flex: 1,
                        position: 'relative',
                        borderRadius: { xs: 0, md: 3 },
                        overflow: 'hidden',
                        boxShadow: { md: 3 },
                        height: '84%',
                    }}
                >
                    <Tooltip title={sidebarOpen ? t("map.closeList") : t("map.openList")}>
                        <IconButton
                            onClick={() => setSidebarOpen(prev => !prev)}
                            sx={{
                                position: 'absolute',
                                top: 80,
                                left: 5,
                                zIndex: 1000,
                                backgroundColor: 'white',
                                boxShadow: 2,
                                borderRadius: '50%',
                                width: 48,
                                height: 48,
                                "&:hover": {
                                    backgroundColor: "white",
                                    opacity: 1,
                                },
                            }}
                        >
                            {sidebarOpen ? <CloseIcon /> : <ListIcon />}
                        </IconButton>
                    </Tooltip>

                    <MapView
                        selectedId={selectedId}
                        sidebarOpen={sidebarOpen}
                        selectedIds={selectedIds}
                    />
                </Box>
            </Box>
        </LocationProvider>
    );
};

export default LocationIndex;
